import type { ValueOf } from '@shared/lib'

export const TabsVariant = { underline: 'underline', pill: 'pill', button: 'button' } as const
export type TabsVariant = ValueOf<typeof TabsVariant>

/** Что делать, когда вкладки не помещаются в строку: перенести на следующую или прокручивать полосу. */
export const TabsOverflow = { wrap: 'wrap', scroll: 'scroll' } as const
export type TabsOverflow = ValueOf<typeof TabsOverflow>
